export const RepriseSkeleton = () => (
  <div className="flex animate-pulse flex-col gap-4 rounded-2xl border border-white/5 bg-white/[0.02] p-4">
    <div className="aspect-video w-full rounded-xl bg-white/5" />
    <div className="h-4 w-3/4 rounded bg-white/5" />
    <div className="h-3 w-1/2 rounded bg-white/5" />
    <div className="mt-auto h-6 w-full rounded-full bg-white/5" />
  </div>
)
